import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";

const EventInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    competition: data?.competition || "",
    competition_id: data?.competition?.id || "",
    blog_categories: data?.categories?.map((category) => category.id) || [],
    term_id: data?.term?.id || "",
    host_country: data?.host_country?.name || "",
    start_date: data?.start_date || "",
    end_date: data?.end_date || "",
    final_city: data?.final_city?.name || "",
    final_stadium: data?.final_stadium || "",
    show_in_profile: data?.show_in_profile || BOOLEAN_OPTIONS.NO,
    thumbnail_url: data?.thumbnail_url || "",
    banner_url: data?.banner_url || "",
    sub_title: data?.sub_title || "",
    content: data?.content || "",
    history_status: data?.status || STATUS.INACTIVE,
    auto_translate: data?.auto_translate ?? BOOLEAN_OPTIONS.NO,
  };
};

export default EventInitialValues;